import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dashboard"
export default class extends Controller {
  static targets = ["todoTotal", "prohibitedTotal", "performance"]

  connect() {
    console.log("Dashboard controller connected")
    
    // Listen for global completion events
    document.addEventListener('completion:updated', this.handleCompletionUpdate.bind(this))
  }

  disconnect() {
    document.removeEventListener('completion:updated', this.handleCompletionUpdate.bind(this))
  }

  // Handle completion updates from global events
  handleCompletionUpdate(event) {
    const { itemType, itemId, newCount } = event.detail
    console.log('Dashboard received completion update:', event.detail)
    this.updateSummary()
  }

  // Listen for completion updates (legacy method for direct event binding)
  completionUpdated(event) {
    const { itemType, itemId, newCount } = event.detail
    this.updateSummary()
  }

  updateSummary() {
    // Recalculate totals from all count displays
    let todoTotal = 0
    let prohibitedTotal = 0

    // Sum up all todo counts
    document.querySelectorAll('[id^="count-todo-"]').forEach(element => {
      todoTotal += parseInt(element.textContent) || 0
    })

    // Sum up all prohibited counts
    document.querySelectorAll('[id^="count-prohibited-"]').forEach(element => {
      prohibitedTotal += parseInt(element.textContent) || 0
    })

    // Update display with animation
    this.animateNumberChange(this.todoTotalTarget, todoTotal)
    this.animateNumberChange(this.prohibitedTotalTarget, prohibitedTotal)

    // Update performance indicator
    this.updatePerformance(todoTotal, prohibitedTotal)
  }

  animateNumberChange(element, newValue) {
    const currentValue = parseInt(element.textContent) || 0
    
    if (currentValue !== newValue) {
      // Add animation class
      element.style.transform = 'scale(1.1)'
      element.style.transition = 'transform 0.3s ease-in-out'
      
      setTimeout(() => {
        element.textContent = newValue
        element.style.transform = 'scale(1)'
        
        // Add flash effect
        element.style.color = '#3b82f6' // Tailwind blue-500
        setTimeout(() => {
          element.style.color = ''
        }, 500)
      }, 150)
    }
  }

  updatePerformance(todoTotal, prohibitedTotal) {
    if (this.hasPerformanceTarget) {
      const performanceElement = this.performanceTarget
      let performance, className
      
      if (todoTotal > 0 && prohibitedTotal === 0) {
        performance = "优秀"
        className = "text-success"
      } else if (todoTotal > prohibitedTotal) {
        performance = "良好"
        className = "text-info"
      } else if (todoTotal === 0 && prohibitedTotal === 0) {
        performance = "待开始"
        className = "text-muted"
      } else {
        performance = "需改进"
        className = "text-warning"
      }
      
      // Update with animation
      performanceElement.style.transform = 'scale(1.1)'
      performanceElement.style.transition = 'transform 0.3s ease-in-out'
      
      setTimeout(() => {
        performanceElement.textContent = performance
        performanceElement.className = `h3 ${className}`
        performanceElement.style.transform = 'scale(1)'
      }, 150)
    }
  }

  // Method to refresh dashboard data via Turbo
  refreshData() {
    fetch(window.location.href, {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error refreshing dashboard:', error)
    })
  }
}
